import ApiService from "../../commons/api/api_service";
import BaseResponse from "../../commons/api/base_response";
import { Endpoints } from "../../commons/api/endpoints";
import ViewModel from "../../commons/base/view_model";
import SoldOutMenuDashboardState from "../models/sold_out_menu_dashboard_state";
import SoldOutMenu from "../models/sold_out_menu_model";

export default interface ResponseModel {
    soldOutMenuPerOutlet: {
        outlet: string;
        majorMenus: SoldOutMenu[],
        minorMenus: SoldOutMenu[]
    }[]
}

export default class SoldOutMenuDashboardViewModel extends ViewModel<SoldOutMenuDashboardState> {

    constructor() {
        super({
            majorMenuPerOutlet: new Map(),
            minorMenuPerOutlet: new Map()
        });
        this.loadData();
    }

    loadData() {
        ApiService.fetch(Endpoints.getSoldOutMenu, {
            onSuccess: (
                response: BaseResponse<ResponseModel>
            ) => {
                if (response && response.code == 200) {
                    const newData = response.data?.soldOutMenuPerOutlet;
                    if (newData) {
                        const newMajor = new Map();
                        const newMinor = new Map();
                        newData.forEach((data) => {
                            newMajor.set(data.outlet, data.majorMenus);
                            newMinor.set(data.outlet, data.minorMenus);
                        });
                        this.emit((state) => {
                            state.majorMenuPerOutlet = newMajor;
                            state.minorMenuPerOutlet = newMinor;
                        });
                    }
                } else {
                    throw new Error("Terjadi error, silakan coba refresh halaman web");
                }
            },
            onFailure: (error) => {
                this.emit((state) => {
                    state.errorMessage = "Terjadi error, silakan coba refresh halaman web";
                });
            }
        });
    }
}